import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import cx from 'classnames';
import mapValues from 'lodash/mapValues';

import MainOptions from './components/MainOptions';

import '../../styles/Licensing.scss';

export default class Licensing extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        useClassBased: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        options: PropTypes.object.isRequired,
        isAdmin: PropTypes.bool,
        className: PropTypes.string,
    };

    state = {
        options: [],
        useClassBased: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            options: props.options,
            useClassBased: props.useClassBased,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.name !== this.props.name) {
            const { useClassBased, options } = this.props;

            this.setState({
                useClassBased,
                options,
            });
        }
    }

    onMainOptionsChange = (options) => {
        if (this.state.useClassBased || this.props.isAdmin) {
            return;
        }

        this.setState(
            (state) => ({
                ...state,
                options,
            }),
            this.onChange
        );
    }

    onClassBasedOptionChange = () => {
        if (this.props.isAdmin) {
            return;
        }

        this.setState(
            (state) => ({
                ...state,
                useClassBased: !state.useClassBased,
            }),
            this.onChange
        );
    }

    onChange = () => {
        const { onChange, name } = this.props;
        const { useClassBased, options } = this.state;

        onChange(name, useClassBased, options);
    }

    render() {
        const { useClassBased } = this.state;
        const { options, isAdmin, className } = this.props;

        return (
            <div className={cx("User-details-settings-licensing", className)}>
                <div 
                    className={cx(
                        'User-details-settings-licensing__class-based-option',
                        { 'User-details-settings-licensing__class-based-option-disabled': isAdmin }
                    )}
                >
                    <input 
                        type="checkbox" 
                        id="User-details-settings-licensing__class-based" 
                        checked={useClassBased}
                        onChange={this.onClassBasedOptionChange}
                    />
                    <label htmlFor="User-details-settings-licensing__class-based">{I18n.t('Use class based options')}</label>
                </div>
                <MainOptions 
                    className={cx(
                        'User-details-settings-licensing__main-options', 
                        { 'User-details-settings-licensing__main-options-disabled': useClassBased || isAdmin }
                    )}
                    options={isAdmin ? mapValues(options, () => true) : options} 
                    onChange={this.onMainOptionsChange} 
                />
            </div>
        );
    }
}